import GearboxLocations from './GearboxLocations'

export default GearboxLocations
